import { call, patch } from "@/services/api";

// `suggested`: nothing saved yet, and the catalogue says a sofa in two parts (his "2 pieces ?").
export type Composition = { myotaku_product_id: number; piece_names: string[]; suggested?: boolean };

export const fetchComposition = (productId: number) => call<Composition>(`/api/v1/product_profiles/${productId}`);
export const saveComposition = (productId: number, pieceNames: string[]) =>
  patch<Composition>(`/api/v1/product_profiles/${productId}`, { piece_names: pieceNames });
